export interface AttachmentReference {
    id: string;
    resourceId: string;
    resourceType: ResourceType;
    fileName: string;
    fileExtension: string;
    fileType: FileType;
    resourcePath: string;
    resourceLink: string;
    thumbnail: string;
    resourceBase64: string;
    isImage: boolean;
    file?: File;
}

/**
 * Tipologia di allegato
 */
export enum FileType {
    Attachment,
    Photo,
    Temp,
    Privacy
}

/**
 * Contesto appartenenza allegati
 */
export enum ResourceType {
    Registry,
    Item,
    FirePrevention,
    Monitoring,
    Temp,
    UserLogo,
    Application
}